import { render, staticRenderFns } from "./CardFields.vue?vue&type=template&id=5dccdaaf&"
import script from "./CardFields.vue?vue&type=script&lang=js&"
export * from "./CardFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports